export function updateColorButtons(selectedColor) {
  const container = getContainer()
  if (!container) return
  
  const colorButtons = getColorButtons(container)
  colorButtons.forEach(element => {
    updateButton(element, selectedColor)
  })
}

function getContainer() {
  return document.getElementById('color-picker-container')
}

function getColorButtons(container) {
  return container.querySelectorAll('[data-controller~="color-picker"]')
}

function updateButton(element, selectedColor) {
  const controller = window.Stimulus?.getControllerForElementAndIdentifier(element, 'color-picker')
  controller?.updateSelection(selectedColor)
}
